<template>
  <v-dialog
    v-model="dialog"
    :max-width="step === 'intro' ? 540 : 640"
    persistent
    content-class="cascade-setup-dialog"
  >
    <!-- Step 1: intro -->
    <div v-if="step === 'intro'" class="cascade-modal">
      <div class="modal-hero">
        <div class="modal-hero-icon" aria-hidden="true">
          <span /><span /><span />
        </div>
        <span class="modal-kicker">Каскадная отправка</span>
        <h3>Добавить резервный канал?</h3>
        <p>
          Если основной канал временно недоступен, Data Heroes переключит отправку на запасной.
          Так сервисные уведомления продолжают доходить до клиентов.
        </p>
      </div>

      <div class="modal-benefits">
        <div>
          <strong>+ стабильность</strong>
          <span>меньше зависимость от одного мессенджера</span>
        </div>
        <div>
          <strong>+ каскад</strong>
          <span>резерв включится автоматически по приоритету</span>
        </div>
      </div>

      <div class="modal-actions">
        <button type="button" class="btn primary" @click="goToPicker">
          Выбрать канал
        </button>
        <button type="button" class="btn ghost" @click="handleSkip">
          Позже
        </button>
      </div>
    </div>

    <!-- Step 2: channel picker -->
    <div v-else class="channel-picker-modal">
      <div class="picker-head">
        <span class="modal-kicker picker-kicker">Новый канал</span>
        <h3>Выберите канал для каскада</h3>
        <p>
          Подключите дополнительный мессенджер. После авторизации он появится в настройках схем отправки.
        </p>
      </div>

      <div class="picker-list">
        <button
          v-for="channel in channels"
          :key="channel.type"
          type="button"
          class="picker-option"
          @click="handleSelectChannel(channel.type)"
        >
          <span class="mini-icon" :class="channel.iconClass">
            <img :src="channel.logo" :alt="channel.name" class="channel-logo" />
          </span>
          <span class="picker-copy">
            <strong>{{ channel.name }}</strong>
            <em>{{ channel.description }}</em>
          </span>
        </button>
      </div>

      <div class="picker-cancel">
        <button type="button" @click="goToIntro">Отмена</button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { CHANNEL_TYPES } from '@/vars/general'

export default {
  name: 'CascadeSetupModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      step: 'intro', // 'intro' | 'picker'
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    channels() {
      return [
        {
          type: CHANNEL_TYPES.whatsappChannel,
          name: 'WhatsApp',
          description: 'Рабочий номер через QR-код',
          logo: require('@/assets/img/messenger-logo/wa-logo.png'),
          iconClass: 'wa',
        },
        {
          type: CHANNEL_TYPES.telegramChannel,
          name: 'Telegram',
          description: 'Подключение через устройство',
          logo: require('@/assets/img/messenger-logo/telegram-logo.png'),
          iconClass: 'tg',
        },
        {
          type: CHANNEL_TYPES.maxChannel,
          name: 'MAX',
          description: 'Номерной канал через QR-код',
          logo: require('@/assets/img/messenger-logo/max-logo.png'),
          iconClass: 'mx',
        },
      ]
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.step = 'intro'
      }
    },
  },
  methods: {
    goToPicker() {
      this.step = 'picker'
    },
    goToIntro() {
      this.step = 'intro'
    },
    handleSkip() {
      this.$emit('skip')
    },
    handleSelectChannel(channelType) {
      // Тот же event, что и раньше; тип канала — доп. аргумент для родителя
      this.$emit('connect-second-channel', channelType)
    },
  },
}
</script>

<style lang="sass">
.cascade-setup-dialog
  box-shadow: none !important
  background: transparent !important
  overflow: visible !important

  .v-dialog
    box-shadow: none !important
</style>

<style lang="sass" scoped>
.cascade-modal
  width: 100%
  text-align: left
  overflow: hidden
  background: #fff
  border-radius: 26px
  box-shadow: 0 32px 90px rgba(16, 22, 41, .28)
  border: 1px solid rgba(255, 255, 255, .22)

.modal-hero
  position: relative
  overflow: hidden
  padding: 28px 28px 24px
  background: radial-gradient(120% 120% at 100% 0%, rgba(212, 236, 56, .26), transparent 42%), linear-gradient(135deg, #101629 0%, #29336D 100%)
  color: #fff

  &:after
    content: ''
    position: absolute
    right: -54px
    bottom: -72px
    width: 180px
    height: 180px
    border-radius: 50%
    background: rgba(212, 236, 56, .16)

.modal-hero-icon
  width: 48px
  height: 48px
  border-radius: 16px
  background: #D4EC38
  display: flex
  align-items: flex-end
  justify-content: center
  gap: 4px
  padding: 12px
  margin-bottom: 16px
  box-shadow: 0 14px 28px rgba(212, 236, 56, .2)

  span
    width: 6px
    border-radius: 999px
    background: #101629

    &:nth-child(1)
      height: 10px
      opacity: .55

    &:nth-child(2)
      height: 16px
      opacity: .76

    &:nth-child(3)
      height: 22px

.modal-kicker
  position: relative
  z-index: 1
  display: inline-flex
  align-items: center
  gap: 8px
  margin-bottom: 8px
  color: #D4EC38
  font-size: 11px
  font-weight: 900
  text-transform: uppercase
  letter-spacing: .12em

  &:before
    content: ''
    width: 6px
    height: 6px
    border-radius: 50%
    background: currentColor

.modal-hero h3
  position: relative
  z-index: 1
  margin: 0 0 10px
  font-family: Geologica, sans-serif
  font-size: 26px
  line-height: 1.05
  letter-spacing: -.05em
  font-weight: 900
  color: #fff

.modal-hero p
  position: relative
  z-index: 1
  margin: 0
  color: rgba(255, 255, 255, .72)
  font-size: 13px
  line-height: 1.6
  max-width: 420px

.modal-benefits
  display: grid
  grid-template-columns: 1fr 1fr
  gap: 12px
  padding: 18px 20px 0

  div
    border: 1px solid #E6E9F0
    border-radius: 16px
    background: #F8FAFF
    padding: 14px

  strong
    display: block
    color: #1A1A2E
    font-size: 13px
    letter-spacing: -.01em
    margin-bottom: 4px

  span
    display: block
    color: #7A839A
    font-size: 12px
    line-height: 1.4

.modal-actions
  display: flex
  gap: 10px
  justify-content: flex-end
  padding: 18px 20px 20px

  .btn
    height: 40px
    border-radius: 12px
    border: none !important
    padding: 0 18px
    font-family: Geologica, sans-serif
    font-size: 12px
    font-weight: 800
    letter-spacing: .04em
    text-transform: uppercase
    cursor: pointer
    transition: background .15s, transform .15s
    box-shadow: none

    &.primary
      background: #525AD5 !important
      color: #fff !important
      box-shadow: 0 10px 20px rgba(82, 90, 213, .24) !important

      &:hover
        background: #454CC0 !important

    &.ghost
      background: #F3F5FC !important
      color: #667085 !important

      &:hover
        background: #EEF0FF !important

.channel-picker-modal
  width: 100%
  text-align: left
  overflow: hidden
  background: #fff
  border-radius: 26px
  box-shadow: 0 32px 90px rgba(16, 22, 41, .28)
  border: 1px solid rgba(255, 255, 255, .22)

.picker-head
  padding: 24px 24px 16px
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%)
  border-bottom: 1px solid #E6E9F0

  h3
    margin: 0 0 8px
    font-family: Geologica, sans-serif
    font-size: 24px
    line-height: 1.08
    letter-spacing: -.045em
    font-weight: 900
    color: #1A1A2E

  p
    margin: 0
    color: #7A839A
    font-size: 13px
    line-height: 1.55
    max-width: 480px

.picker-kicker
  color: #525AD5

.picker-list
  display: grid
  grid-template-columns: repeat(2, minmax(0, 1fr))
  gap: 12px
  background: #fff
  padding: 18px 20px 8px

.picker-option
  position: relative
  min-height: 106px
  border: 1.5px solid #E6E9F0
  background: #fff
  display: flex
  align-items: flex-start
  gap: 12px
  padding: 16px
  border-radius: 18px
  color: #1A1A2E
  font-weight: 600
  text-align: left
  cursor: pointer
  transition: transform .16s ease, border-color .16s ease, box-shadow .16s ease, background .16s ease

  &:hover
    background: #FBFCFF
    border-color: rgba(82, 90, 213, .42)
    box-shadow: 0 16px 34px rgba(82, 90, 213, .12)
    transform: translateY(-2px)

.mini-icon
  width: 48px
  height: 48px
  border-radius: 16px
  flex: 0 0 auto
  display: grid
  place-items: center
  overflow: hidden

  &.wa
    background: #29a71a

  &.tg
    background: #24aaec

  &.mx
    background: #3b47ec

.channel-logo
  width: 100%
  height: 100%
  object-fit: contain
  display: block

.picker-copy
  display: block
  padding-right: 6px

  strong
    display: block
    font-size: 15px
    line-height: 1.2
    letter-spacing: -.02em
    margin-bottom: 5px
    color: #1A1A2E

  em
    display: block
    font-style: normal
    color: #7A839A
    font-size: 12px
    line-height: 1.4
    font-weight: 500

.picker-cancel
  display: flex
  justify-content: flex-end
  padding: 12px 20px 20px

  button
    height: 36px
    border: 0
    background: #F3F5FC
    color: #667085
    border-radius: 10px
    padding: 0 14px
    font-family: Geologica, sans-serif
    font-weight: 900
    text-transform: uppercase
    font-size: 11px
    letter-spacing: .04em
    cursor: pointer

    &:hover
      background: #EEF0FF

@media (max-width: 640px)
  .modal-benefits
    grid-template-columns: 1fr

  .modal-actions
    flex-direction: column

    .btn
      width: 100%

  .picker-list
    grid-template-columns: 1fr

  .cascade-modal,
  .channel-picker-modal
    border-radius: 22px
</style>
